import * as React from 'react';
import Icon from 'components/atomic/Icon';
import { ICONS_ALIASES } from '_constants/icons';
import { theme } from '_constants/theme';
import styled from 'styled-components';
import { TrademarksPackage } from '_constants/trademarksPackage';
const { colors, fontSizes, spaces } = theme;

export default function PackageList2() {
  const StyleTable = styled.div`
    display: flex;
    flex-direction: column;
    @media (max-width: 768px) {
      display: none;
    }
  `;
  const StyleRow = styled.div`
    display: flex;
    min-height: 50px;
  `;
  const StyleHeader = styled.div`
    font-family: Montserrat;
    font-size: 18px;
    font-weight: 600;
    line-height: 22px;
    color: ${colors.blue[750]};
  `;
  const StyleText = styled.div`
    font-family: Montserrat;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    color: ${colors.gray[450]};
  `;
  const StyleCell = styled.div`
    flex-grow: 2;
    border: 1px solid #d0d2d4;
    padding: 16px;
    min-height: 140px;
    display: flex;
    justify-content: center;
    flex-direction: column;
  `;
  const StyleCenterCell = styled.div`
    flex-grow: 1;
    min-width: 22%;
    max-width: 22%;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #d0d2d4;
  `;
  return (
    <StyleTable>
      {TrademarksPackage &&
        TrademarksPackage.map((item, j) => (
          <StyleRow key={j}>
            <StyleCell>
              <StyleHeader>{item.header}</StyleHeader>
              <StyleText>{item.text}</StyleText>
            </StyleCell>
            <StyleCenterCell>
              {item.BASIC === 1 ? (
                <Icon
                  alias={ICONS_ALIASES.starCheck}
                  color={colors.orange[450]}
                />
              ) : (
                <Icon
                  alias={ICONS_ALIASES.sadCircle}
                  color={colors.gray[450]}
                />
              )}
            </StyleCenterCell>
            <StyleCenterCell>
              {item.DELUXE === 1 ? (
                <Icon
                  alias={ICONS_ALIASES.starCheck}
                  color={colors.blue[750]}
                />
              ) : (
                <Icon
                  alias={ICONS_ALIASES.sadCircle}
                  color={colors.gray[450]}
                />
              )}
            </StyleCenterCell>
            <StyleCenterCell>
              {item.PREMIER === 1 ? (
                <Icon
                  alias={ICONS_ALIASES.starCheck}
                  color={colors.orange[450]}
                />
              ) : (
                <Icon
                  alias={ICONS_ALIASES.sadCircle}
                  color={colors.gray[450]}
                />
              )}
            </StyleCenterCell>
          </StyleRow>
        ))}
    </StyleTable>
  );
}
